<template>
  <div>
      <div class="bg-white mx-n5">
        <b-row class="justify-content-center">
          <b-col md="6" class="text-center py-4">
            <img src="img/brand/logo.jpg" width="160">
            <div class="pt-3">
              <span class="text-muted ">Down To Earth Labs Electronic Laboratory Management</span>
            </div>
            <b-input-group class="pt-3" v-if="isLoggedIn">
<!--              <b-form-input class="text-uppercase font-weight-bolder text-muted" placeholder="Search for a sample"></b-form-input>-->
<!--              <b-input-group-append>-->
<!--                <b-button variant="dark"><i class="fal fa-search"></i></b-button>-->
<!--              </b-input-group-append>-->
            </b-input-group>
          </b-col>
        </b-row>
      </div>
      <div>
        <b-row class="justify-content-center">
          <b-col md="8" class="text-center py-5">
            <dashboard-tiles :items="nav"></dashboard-tiles>
          </b-col>
        </b-row>
      </div>
  </div>
</template>

<script>
  import nav from '@/_nav'
  import nav_guest from '@/_nav_guest'
  import DashboardTiles from "../components/dashboard/DashboardTiles";

  export default {
    components: {DashboardTiles},
    name: 'Dashboard',
    computed: {
      isLoggedIn () {
        return this.$store.getters.isAuthenticated;
      },
      authType () {
        return this.$store.getters.getAuthType;
      },
      nav() {
        const isAuthenticated = this.$store.getters.isAuthenticated;
        const authType = this.$store.getters.getAuthType;

        if (isAuthenticated) {
          if (authType === 'token') {
            return [
              {name: 'Results', icon: 'fal fa-vials', url: '/results'},
            ];
          }
          return nav.items;
        }
        return nav_guest.items;
      }
    },
  }
</script>
